<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Reward Name </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="giftName" name="search" clearable @clear="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Source Type </label>
          <div class="col-sm-4">
            <div>
              <el-select @clear="search" v-model="sourceType" v-bind:placeholder='$t("message.PleaseSelect")'>
                <el-option v-for="item in sourceTypeMap" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Redemption Member No. </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="memberNo" name="search" clearable @clear="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Create Date & Time </label>
          <div class="col-sm-4">
            <div>
              <el-date-picker v-model="selectDate" type="daterange" start-placeholder="Start date"
                end-placeholder="End date">
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label">
            Batch Uuid
          </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="batchUuid" name="search" clearable @clear="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-sm-12">
                <div class="pull-right" style="display: flex;">
                  <el-button @click="gotoDetail" v-if="checkPermission('gift_inventory_log_ADD')">{{ $t("message.Add")
                  }}</el-button>
                  <el-upload class="upload-demo" action="#" style="margin:0 10px" :http-request="handleImport"
                    :auto-upload="true" accept=".xlsx, .xls" :show-file-list="false">
                    <el-button>Import</el-button>
                  </el-upload>
                  <el-button class="header-btn" @click="handleExport">Export Update History</el-button>
                  <el-button class="header-btn" @click="handleExportStoreInventory">Export Inventory Summary</el-button>

                </div>
              </div>
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table :data="rows" border style="width: 100%" ref="multipleTable" row-key="id">

                <el-table-column prop="giftName" label="Reward Name" width="180">
                </el-table-column>
                <el-table-column prop="memberNo" label="Redemption Member No" width="180">
                </el-table-column>
                <el-table-column prop="storeName" label="Center Name" width="180">
                </el-table-column>
                <el-table-column prop="inventory" label="Inventory">
                </el-table-column>
                <el-table-column prop="isHq" label="HQ WH">
                  <template slot-scope="scope">
                    {{ scope.row.isHq?'Yes':'No' }}
                  </template>
                </el-table-column>
                <el-table-column prop="isPublic" label="Public WH">
                  <template slot-scope="scope">
                    {{ scope.row.isPublic?'Yes':'No' }}
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="Type">
                  <template slot-scope="scope">
                    {{ typeMap[scope.row.type] }}
                  </template>
                </el-table-column>
                <el-table-column prop="createdAt" width="170" label="Create Date & Time">
                </el-table-column>
                <el-table-column prop="batchUuid" label="Batch Uuid" width="190">
                </el-table-column>
                <el-table-column label="Action" width="120" fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" v-if="checkPermission('gift_inventory_log_VIEW')"
                      @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
                  :total="total" style="float: right">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import config from "../config";
import axios from "axios"
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      total: 0,
      rows: [],
      giftName: '',
      multipleSelection: [],
      sortType: "desc",
      sortName: "title",
      sourceType: "",
      memberNo: "",
      selectDate: [],
      batchUuid: ""
    };
  },
  components: {
  },
  computed: {
    typeMap() {
      return {
        1: "Increase",
        2: "Reduce",
        3: "Refund increase",
        4: 'Request delivery'
      }
    },
    sourceTypeMap() {
      return [
        { value: "", label: "All" },
        { value: 1, label: "Manual" },
        { value: 2, label: "Member" },
      ]
    }
  },
  created() {
  },
  methods: {
    async init() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.giftName = this.giftName;
      objdata.sortName = this.sortName;
      objdata.sortType = this.sortType;
      objdata.sourceType = this.sourceType;
      objdata.memberNo = this.memberNo;
      objdata.batchUuid = this.batchUuid
      objdata.begDate = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[0]).format("YYYY-MM-DD") : '';
      objdata.endDate = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[1]).format("YYYY-MM-DD") : '';

      objdata.apiUrl = this.apiConfig.giftInventoryLogList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.giftInventoryLogList;
      this.total = data.data.result.total;
    },
    async getRewardsList() {

    },
    async search() {
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/giftInventoryLogDetail",
        query: {
          id: row.id,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/giftInventoryLogDetail" });
    },
    async handleImport(params) {
      let obj = this.getAuthObj();
      obj.file = params.file;
      obj.apiUrl = this.apiConfig.giftInventoryImport;
      var data = await this.$store.dispatch("apiEventFromData", obj);
      if (data == this.TOKEN_EXPIRED) {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: "Import Success",
        type: "success",
      });
      this.init();
    },
    async handleExport() {
      var that = this;
      if (!(this.selectDate && this.selectDate.length && this.selectDate[0] && this.selectDate[1])) {
        this.$store.commit("setwarning", {
          string: 'Please enter Create Date  (Start / End) to export data.',
          boolean: true,
          button: [{
            name: "Cancel",
            callBack: function () {
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            }
          }]
        });
      } else {
        var objdata = this.getAuthObj();
        objdata.begDate = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[0]).format("YYYY-MM-DD") : '';
        objdata.endDate = this.selectDate && this.selectDate.length && this.selectDate[0] ? this.$dayjs(this.selectDate[1]).format("YYYY-MM-DD") : '';
        objdata.giftName = this.giftName;
        objdata.sourceType = this.sourceType;
        objdata.memberNo = this.memberNo;
        let data = await axios.post(`${config.domain}` + this.apiConfig.giftInventoryExport, objdata, { 'responseType': 'blob' })
        if (data.data.status_code == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!(data && data.data)) return;
        if (data.data.status_code && data.data.status_code != '0') {
          this.$store.commit("setwarning", {
            string: data.data.status_message,
            boolean: true,
            button: [{
              name: "Cancel",
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }]
          });
        } else {
          const xlsFileName = 'Inventory History_' + this.$dayjs(objdata.begDate).format('YYYYMMDD') + ' - ' + this.$dayjs(objdata.endDate).format('YYYYMMDD') + '.xls'
          const url = window.URL.createObjectURL(new Blob([data.data]), { type: "application/json" });
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", xlsFileName);
          document.body.appendChild(link);
          link.click();
        }
      }
    },
    async handleExportStoreInventory() {
      var that = this;
      var objdata = this.getAuthObj();
      let data = await axios.post(`${config.domain}` + this.apiConfig.giftInventoryExportStoreInventory, objdata, { 'responseType': 'blob' })
      if (data.data.status_code == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!(data && data.data)) return;
      if (data.data.status_code && data.data.status_code != '0') {
        this.$store.commit("setwarning", {
          string: data.data.status_message,
          boolean: true,
          button: [{
            name: "Cancel",
            callBack: function () {
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            }
          }]
        });
      } else {
        const xlsFileName = 'Inventory Summary_' + this.$dayjs(objdata.begDate).format('YYYYMMDD') + ' - ' + this.$dayjs(objdata.endDate).format('YYYYMMDD') + '.xls'
        const url = window.URL.createObjectURL(new Blob([data.data]), { type: "application/json" });
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", xlsFileName);
        document.body.appendChild(link);
        link.click();
      }

    },
  },
  mounted() {
    this.init();
  },

};
</script>
  